<template>
	<div class="tw-flex tw-gap-2">
		<AppButton
			:label="$t('products.create-new-rule')"
			startIcon="assets/v2/image/icons/plus.svg"
			@click="goToCreate"
		/>
	</div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();

const goToCreate = () => {
	router.push('/v2/products/repricing-rules/create');
};
</script>

<style lang="scss" scoped></style>
